export default "__VITE_ASSET__BSDH$J0Q__"